import { render, staticRenderFns } from "./CompanyInfo.vue?vue&type=template&id=43396977&scoped=true"
import script from "./CompanyInfo.vue?vue&type=script&lang=js"
export * from "./CompanyInfo.vue?vue&type=script&lang=js"
import style0 from "./CompanyInfo.vue?vue&type=style&index=0&id=43396977&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43396977",
  null
  
)

export default component.exports